import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { RenaultLocalCampaignDTO } from '../../../models/renault-local-campaign-dto';
import { RenaultLocalCampaignOrderDTO } from '../../../models/renault-local-campaign-order-dto';
import { FileService } from '../../../services/file.service';
import { LocalCampaignOrderService } from '../../../services/local-campaign-order.service';
import { LocalCampaignService } from '../../../services/local-campaign.service';
import { LocalCampaignMedia } from '../../../helpers/enum';

@Component({
  selector: 'local-campaign-html-modal',
  templateUrl: './local-campaign-html-modal.component.html',
  styleUrls: ['./local-campaign-html-modal.component.scss']
})
export class LocalCampaignHtmlModalComponent implements OnInit {

  @Input() idOrder: string;
  modelOrder: RenaultLocalCampaignOrderDTO;
  modelCampign: RenaultLocalCampaignDTO;
  htmlOutput: SafeHtml;
  urlBase = environment.urlAPI;
  LocalCampaignMedia = LocalCampaignMedia;

  constructor(public activeModal: NgbActiveModal,
    private orderService: LocalCampaignOrderService,
    private campaignService: LocalCampaignService,
    private fileService: FileService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getCampaignOrder();
  }

  getCampaignOrder() {
    this.orderService.get(this.idOrder).subscribe(resp => {
      this.modelOrder = resp;
      this.getCampaign();
    });
  }

  getCampaign() {
    this.campaignService.get(this.modelOrder.IdCampaign).subscribe(resp => {
      this.modelCampign = resp;
      this.previewFile();      
    });
  }

  previewFile() {
    if (this.modelCampign.HtmlOutputFile != null) {
      this.fileService.getFileDataTextByUrl(this.modelCampign.HtmlOutputFile.FileUri).subscribe(resp => {
        let formData = JSON.parse(this.modelOrder.Data);
        formData.push({ Key: 'UrlBase', Value: this.urlBase });
        formData.forEach(function (dataForm) {
          let re = new RegExp('&&' + dataForm.Key + '&&', 'gi');
          resp = resp.replace(re, dataForm.Value);
        });
        this.htmlOutput = this.sanitizer.bypassSecurityTrustHtml(resp);
      });
    }
  }
}
